<template>
  <div class="main">
    <LayoutVue />
    <TopbgVue title="发布信息" />
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择栏目" prop="region">
          <el-select v-model="ruleForm.region" placeholder="请选择栏目">
            <el-option label="二手车" :value="1"></el-option>
            <el-option label="二手闲置" :value="2"></el-option>
            <el-option label="房屋出租" :value="3"></el-option>
            <el-option label="生活服务" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input style="width: 50%" v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="time">
          <el-select v-model="ruleForm.time" placeholder="请选有效期">
            <el-option label="长期有效" :value="1"></el-option>
            <el-option label="一周" :value="2"></el-option>
            <el-option label="一个月" :value="3"></el-option>
            <el-option label="两个月" :value="4"></el-option>
            <el-option label="一年" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="desc">
          <el-input
            style="width: 50%"
            type="textarea"
            v-model="ruleForm.desc"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="img">
          <el-upload
            class="upload-demo"
            action="customize"
            :limit="1"
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="联系人" prop="username">
          <el-input style="width: 50%" v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input style="width: 50%" v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input style="width: 50%" v-model="ruleForm.pass"></el-input>
          <p style="font-size: 16px; color: #717275">
            预留一串密码（6位以上），作为日后修改、取消信息的重要凭证。
          </p>
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 200px"
            type="primary"
            @click="submitForm('ruleForm')"
            >立即发布</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <Footer />
  </div>
</template>

<script>
import LayoutVue from "./Layout.vue";
import Footer from "./footer.vue";
import TopbgVue from "./Topbg.vue";
export default {
  name: "Releaseinfo",
  data() {
    return {
      ruleForm: {
        img:''
      },
      rules: {
        region: [{ required: true, message: "请选择栏目", trigger: "change" }],
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        time: [{ required: true, message: "请选有效期", trigger: "change" }],
        desc: [{ required: true, message: "请填写内容", trigger: "blur" }],
        username: [
          { required: true, message: "请填写联系人", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请填写手机号", trigger: "blur" }],
        pass: [{ required: true, message: "请填写密码", trigger: "blur" }],
        img: [{ required: true, message: "请上传图片", trigger: "change" }],
      },
      fileList: [],
    };
  },
  components: {
    LayoutVue,
    Footer,
    TopbgVue,
  },
  methods: {
    // 自定义上传事件
    uploadFile(params) {
      this.ruleForm.img = params.file
      console.log(params.file, "上传的文件");
      // this.ruleForm.paramsFile = params.file;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.$message({
            message: "发布成功！",
            type: "success",
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  .content {
    max-width: 1300px;
    height: auto;
    margin: 100px auto 0;
    /deep/ .el-upload-list {
      width: 50%;
    }
  }
}
</style>